import React, { Component } from 'react'
import Icon from './Icon'

class Collapse extends Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg x='0px' y='0px' width='18px' height='18px' viewBox='0 0 18 18'>
          <g transform='translate(-147.000000, -51.000000)'>
            <g transform='translate(144.000000, 48.000000)'>
              <path
                fill='#7E8DA2'
                d='M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3L19,3z M17,13H7v-2h10V13L17,13z'
              />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Collapse
